var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slo-input-wrapper"},[_c('label',{directives:[{name:"stack-x",rawName:"v-stack-x:2xs",arg:"2xs"}],ref:"root",class:{
      'slo-input': true,
      [`size-${_vm.size}`]: _vm.size,
      [`variant-${_vm.variant}`]: _vm.variant,
      [`type-${_vm.type}`]: true,
      checked: _vm.checked,
      indeterminate: _vm.indeterminate,
      disabled: _vm.disabled || _vm.fieldState.disabled,
      'focus-within': _vm.fieldState.focusWithin,
      'slo-input--error': _vm.error,
      'slo-input--has-icon': _vm.$slots.start || _vm.$slots.end
    }},[_vm._t("start"),_vm._v(" "),_c('input',_vm._b({ref:"input",attrs:{"type":_vm.type,"disabled":_vm.disabled || _vm.fieldState.disabled},domProps:{"value":_vm.value,"checked":_vm.checked,"indeterminate":_vm.indeterminate},on:{"blur":_vm.handleBlur,"keydown":function($event){$event.stopPropagation();return _vm.handleKeydown.apply(null, arguments)},"input":function($event){$event.stopPropagation();return _vm.handleInput.apply(null, arguments)}}},'input',_vm.$attrs,false)),_vm._v(" "),_vm._t("end")],2),_vm._v(" "),(_vm.errorText)?_c('span',{staticClass:"slo-input--error-message",domProps:{"innerHTML":_vm._s(_vm.errorText)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }